import z from "zod";
import { trackedCustomProductSchema, trackedPageDataSchema } from "../utils";
import { pushGtmEvent } from "./utils";

export const viewItemEventInputSchema = z.object({
  product: trackedCustomProductSchema,
  currency: z.string(),
  pageData: trackedPageDataSchema,
});

export type ViewItemEventInput = z.infer<typeof viewItemEventInputSchema>;

export const viewItemEventPayloadSchema = z
  .object({
    event: z.literal("view_item"),
    ecommerce: z.object({
      item_list_id: z.string().nullish(),
      item_list_name: z.string().nullish(),
      currency: z.string(),
      value: z.number(),
      items: z.array(
        z.object({
          item_id: z.string(),
          item_name: z.string(),
          item_brand: z.string().optional(),
          item_category: z.string().optional(),
          item_category2: z.string().optional(),
          item_category3: z.string().optional(),
          price: z.number(),
        }),
      ),
    }),
  })
  .optional();

export type ViewItemEventPayload = z.infer<typeof viewItemEventPayloadSchema>;

function buildViewItemEventPayload(input: ViewItemEventInput) {
  const data = viewItemEventInputSchema.parse(input);

  if (!data) {
    return;
  }

  return viewItemEventPayloadSchema.parse({
    event: "view_item",
    ecommerce: {
      currency: data.currency,
      value: data.product.price,
      items: [
        {
          item_id: data.product.item_id,
          item_name: data.product.item_name,
          item_brand: data.product.item_brand,
          item_category: data.product.item_category,
          item_category2: data.product.item_category2,
          item_category3: data.product.item_category3,
          item_list_id: data.pageData?.id,
          item_list_name: data.pageData?.title,
          price: data.product.price,
        },
      ],
    },
  });
}

export function viewItemEvent(props: ViewItemEventInput) {
  if (typeof window === "undefined") {
    return;
  }

  if (!props.product) {
    return;
  }

  try {
    const payload = buildViewItemEventPayload({
      product: props.product,
      currency: props.currency,
      pageData: props.pageData,
    });
    pushGtmEvent(payload);
  } catch {}
}
